import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";
import { ArrowLeft } from "lucide-react";

export default function DeleteAccount() {
  return (
    <div className="min-h-screen" data-testid="delete-account-page">
      <header className="border-b-2" style={{ borderColor: "var(--cs-ink)" }}>
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center justify-between">
          <Link to="/" data-testid="delete-page-home"><Logo size={26} /></Link>
          <Link to="/" className="brut-btn brut-btn-ghost text-xs"><ArrowLeft size={14} /> Back</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-12">
        <h1 className="font-display text-5xl font-black tracking-tighter">Delete your account</h1>
        <p className="text-[var(--cs-ink-2)] mt-2 font-semibold">
          You can permanently delete your CashStreak account and associated data at any time.
        </p>

        <Section title="How to delete your account in the app">
          <ol className="list-decimal pl-6 mt-2 space-y-2">
            <li>Log in to CashStreak and go to your <strong>Profile</strong>.</li>
            <li>Scroll to the <strong>Danger zone</strong> section.</li>
            <li>Tap <strong>Delete my account</strong> and confirm with your password.</li>
          </ol>
          <p className="mt-3">
            Before deleting, please <strong>withdraw any wallet balance</strong> and <strong>complete or cancel active tasks</strong> — the app will remind you if either is pending.
          </p>
        </Section>

        <Section title="What gets deleted">
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Your account profile (name, email, password, city)</li>
            <li>Your notifications</li>
            <li>Your name is removed from past tasks and messages (shown as "Deleted user")</li>
          </ul>
        </Section>

        <Section title="What we keep (and why)">
          <p>
            Payment and payout transaction records are retained as required for legal, tax, and fraud-prevention purposes,
            consistent with our <Link className="underline" to="/privacy">Privacy Policy</Link>. These records are no longer linked to an active account.
          </p>
        </Section>

        <Section title="Can't access the app?">
          <p>
            Email us at <a className="underline" href="mailto:support@mycashstreak.com">support@mycashstreak.com</a> from
            the email address on your account and we'll process your deletion request within 30 days.
          </p>
        </Section>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mt-10">
      <h2 className="font-display text-lg md:text-lg font-extrabold">{title}</h2>
      <div className="mt-2 text-[var(--cs-ink)] leading-relaxed">{children}</div>
    </section>
  );
}
